<template>
  <div v-cloak id="app-container">

    <div id="slideout-menu-container" :class="{'slideout-menu-open': mainMenuVisible, 'slideout-menu-close': !mainMenuVisible}" class="slideout-menu rounded-right">
      <div id="menu-header" class="text-center">
        <span class="menu-close" aria-hidden="true" @click="closeMainMenu">&times;</span>
        <h4><i class="pe pe-user-circle-o" aria-hidden="true"/></h4>
        <h5>{{ loggedInUserName }}</h5>
      </div>
      <ul class="nav flex-column">
        <li class="nav-item">
          <a href="#/dashboard" class="nav-link" @click="closeMainMenu">
            <i class="pe pe-dashboard" aria-hidden="true"/> Dashboard
          </a>
        </li>
        <li v-for="(ledger, index) in state.ledger.list" :key="index" class="nav-item">
          <a :href="'#/ledger/' + ledger.id" class="nav-link" style="padding-top: 10px!important;" @click="closeMainMenu">
            <div class="slideout-menu-ledger-icon-box"><i class="pe pe-book" aria-hidden="true"/></div>
            <div class="slideout-menu-ledger-title-box">{{ ledger.name }}</div>
          </a>
        </li>
        <li class="nav-item">
          <a href="#/ledger/create" class="nav-link" @click="closeMainMenu">
            <i class="pe pe-plus" aria-hidden="true"/> Create ledger
          </a>
        </li>
        <div class="dropdown-divider">-</div>
        <li class="nav-item">
          <a href="#/account-settings" class="nav-link" @click="closeMainMenu">
            <i class="pe pe-cogs" aria-hidden="true"/> Account settings
          </a>
        </li>
        <li v-if="state.app.subscriptionEnabled" class="nav-item">
          <a href="#/subscription" class="nav-link" @click="closeMainMenu">
            <i class="pe pe-card" aria-hidden="true"/> Subscription
          </a>
        </li>
        <li class="nav-item">
          <a href="#/support" class="nav-link" @click="closeMainMenu">
            <i class="pe pe-question-circle" aria-hidden="true"/> Help
          </a>
        </li>
        <li class="nav-item">
          <a v-if="state.auth.accessToken" href="#/logout" class="nav-link" @click="closeMainMenu">
            <i class="pe pe-sign-out" aria-hidden="true"/> Logout
          </a>
        </li>
      </ul>
      <br>
      <br>
    </div>

    <div v-if="state.auth.accessToken" id="top-navbar-container">
      <b-navbar type="light" class="top-navbar navbar-laravel" fixed="top">
        <b-navbar-nav>
          <b-nav-item href="" class="account-menu" @click.prevent="toggleMainMenu"><i class="pe pe-user-circle-o" aria-hidden="true"/></b-nav-item>
        </b-navbar-nav>
        <b-navbar-brand href="#/">
          <span v-if="this.$loading.isLoading(['logging-out','fetching-data-from-backend','processing'])" class="top-navbar-spinner"><i class="pe pe-spinner fa-spin" aria-hidden="true"/></span>
          <img src="/img/svg/expense_guide_logo_inside.svg" alt="expense.guide logo" class="logo-topnav">
        </b-navbar-brand>
        <b-navbar-nav>
          <b-nav-item href="#/support"><i class="pe pe-question-circle" aria-hidden="true"/></b-nav-item>
        </b-navbar-nav>
      </b-navbar>
    </div>

    <main id="main-content"
          class="py-4"
          @click="closeMainMenu"
    >
      <router-view/>
    </main>
    <button v-if="!state.app.online" class="btn btn-danger" style="position:fixed;left:25px;bottom:15px;"><b>No internet connection!</b><br>Some features will not work!</button>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import store from './store/index'

export default {
  name: 'AppContainer',
  data () {
    return {
      mainMenuVisible: false
    }
  },
  computed: {
    ...mapState({
      state: state => state
    }),
    loggedInUserName () {
      return this.state.account.me ? this.state.account.me.name : ''
    }
  },
  mounted () {
    let self = this
    window.addEventListener('load', () => {
      function handleNetworkChange (event) {
        if (navigator.onLine) {
          document.body.classList.remove('offline')
          self.SET_APP_ONLINE()
          self.validateAccessToken()
          self.getLedgers()
        } else {
          document.body.classList.add('offline')
          self.SET_APP_OFFLINE()
        }
      }
      window.addEventListener('online', handleNetworkChange)
      window.addEventListener('offline', handleNetworkChange)
    })

    if (!store.state.app.visibilityChangeObserver.app) {
      store.commit('SET_VISIBILITY_CHANGE_OBSERVER_APP', true)
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          console.log('App in background!')
        } else {
          self.getLoggedInUser().then(() => {
            if (self.$router.currentRoute.name === 'Ledger' && !store.state.account.me.subscription.active && !store.state.account.me.subscription.trial && store.state.app.subscriptionEnabled) {
              self.$router.push('/subscription')
            }
          })
        }
      })
    }
  },
  methods: {
    ...mapMutations([
      'SET_APP_ONLINE',
      'SET_APP_OFFLINE'
    ]),
    ...mapActions([
      'validateAccessToken',
      'getLedgers',
      'getLoggedInUser'
    ]),
    toggleMainMenu () {
      this.mainMenuVisible = !this.mainMenuVisible
    },
    closeMainMenu () {
      this.mainMenuVisible = false
    },
    showMainMenu () {
      this.mainMenuVisible = true
    }
  }
}
</script>

<style>
  [v-cloak]{
    display: none
  }
  #main-content{
    min-height: 90vh;
  }
  .slideout-menu {
    position: fixed;
    top: 0;
    left: -100vw;
    bottom: 0;
    width: 83.33vw;
    max-width:300px;
    min-height: 100vh;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    z-index: 9999;
    display: block;
    background-color: #fff;
    color: #061d34;
    /*box-shadow: 0px 3px 15px rgba(0,0,0,0.2);*/
  }
  .slideout-menu-open {
    transition: 0.3s;
    left: 0;
  }
  .slideout-menu-close {
    transition: 0.3s;
    left: -100vw;
  }
  .slideout-menu-ledger-icon-box{
    display: inline-block;
    width:25px;
    float: left;
  }
  .slideout-menu-ledger-title-box{
    display: inline-block;
    width:210px;
    padding-left:3px;padding-top:2px;
    line-height:1.1rem
  }
  @media (max-width: 350px) {
    .slideout-menu-ledger-title-box{
      width:185px;
    }
  }
  *:focus {
    outline: none;
  }
</style>
